import { jsx as _jsx } from "@redneckz/uni-jsx/jsx-runtime";
import { JSX } from '@redneckz/uni-jsx';
import { useEffect } from '@redneckz/uni-jsx/lib/hooks';
import { useBranches } from '../../hooks/useBranches.js';
import { useBranchesByRegions } from '../../hooks/useBranchesByRegions.js';
import { SelectControl } from '../../ui-kit/Select/SelectControl.js';
import { validatorObj } from './getObjectValidator.js';
import { getValidation } from './getValidation.js';
export const AddressBranchField = JSX(({ field, input, isPremium = false }) => {
    const fieldRegion = field('region');
    const regionKey = fieldRegion?.value?.key;
    const regionText = fieldRegion?.value?.text;
    const addressBranch = isPremium
        ? useBranchesByRegions()?.find((_) => _?.region === regionText)?.branches
        : useBranches(regionKey)?.filter((branch) => branch?.address);
    useEffect(() => {
        if (fieldRegion?.value?.key !== '') {
            field?.('addressBranch')?.onChange?.('');
        }
    }, [fieldRegion?.value]);
    return (_jsx(SelectControl, { label: "\u041E\u0442\u0434\u0435\u043B\u0435\u043D\u0438\u0435", placeholder: "\u0412\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u043E\u0442\u0434\u0435\u043B\u0435\u043D\u0438\u0435", options: (addressBranch || []).map(({ address = '' }) => ({
            key: address,
            text: address,
        })), ...getValidation(field('addressBranch'), validatorObj.addressBranch, input?.required), isSearch: true }));
});
//# sourceMappingURL=AddressBranchField.js.map